import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-with-shop-nav-bar',
  templateUrl: './with-shop-nav-bar.component.html'
})
export class WithShopNavBarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
